export default __webpack_public_path__ + "static/media/520.36f52ea1.svga";